import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Tooltip, OverlayTrigger, Button } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import staff1 from '../../../../images/staff/member_2.png';
import staff2 from '../../../../images/staff/member_1.png';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import LeadLimit from './../../../modal/Team_Management/Team_Lead/LeadLimit';
import axios from 'axios';
import LoadingComponent from '../../../layouts/nav/loading';

const TeamLead = () => {


    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ----------------------- branch --------------------
        man_branch: 0,
        branch_list: 0,
        branch_add: 0,
        branch_edit: 0,
        branch_view: 0,
        branch_delete: 0,
        branch_add_staff: 0,
        branch_add_area: 0,
        branch_add_dpoint: 0,
        branch_asign_manager: 0,
        branch_asign_cug: 0,

        man_dpoint: 0,
        dpoint_list: 0,
        dpoint_edit: 0,
        dpoint_delete: 0,
        dpoint_assign_vehicle: 0,

        // --------------------------- pack -------------------
        pack_man: 0,
        man_product: 0,
        prod_catego: 0,
        product_category_list: 0,
        product_category_add: 0,
        product_category_edit: 0,
        product_category_delete: 0,

        product: 0,
        products_list: 0,
        products_add: 0,
        products_edit: 0,
        products_view: 0,
        products_delete: 0,
        products_item_quantity: 0,

        item_quans: 0,
        item_quantity_list: 0,
        item_quantity_edit: 0,
        item_quantity_view: 0,

        man_pack: 0,
        package_list: 0,
        package_edit: 0,
        package_delete: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

        // ------------------------------- subscription ------------------
        subs_man: 0,
        man_subs: 0,
        subscription_list: 0,
        subscription_view: 0,
        subscription_edit: 0,
        subscription_export: 0,
        subscription_hold: 0,
        subscription_complaints: 0,
        subscription_renewal: 0,
        subscription_payment: 0,
        subscription_drop: 0,
        subscription_special_case: 0,

        man_order: 0,
        order_list: 0,
        order_edit: 0,
        order_view: 0,
        order_new_subs: 0,
        order_drop_subs: 0,
        order_convert_subscriber: 0,

        man_drop: 0,
        drop_list: 0,
        drop_export: 0,

        // ----------------------------------- payment ------------------------
        pay_man: 0,
        man_payment: 0,
        payment_export: 0,
        payment_list: 0,

        man_refund: 0,
        refund_list: 0,
        refund_export: 0,
        refund_update: 0,

        // -------------------------- production ----------------------
        prod_man: 0,
        man_items: 0,
        item_catego: 0,
        item_category_list: 0,
        item_category_add: 0,
        item_category_edit: 0,
        item_category_delete: 0,

        item_sub_catego: 0,
        item_sub_category_list: 0,
        item_sub_category_add: 0,
        item_sub_category_edit: 0,
        item_sub_category_delete: 0,

        items: 0,
        items_list: 0,
        items_add: 0,
        items_edit: 0,
        items_view: 0,
        items_delete: 0,
        item_needed_material: 0,
        item_receipe_notes: 0,

        comp_man: 0,
        complaint_list: 0,
        complaint_add: 0,
        complaint_status: 0,
        complaint_view: 0,

        maintenance_man: 0,
        man_vehi: 0,
        vehicle_list: 0,
        vehicle_add: 0,
        vehicle_edit: 0,
        vehicle_view: 0,
        vehicle_delete: 0,
        vehicle_maintannce: 0,
        vehicle_export: 0,

        man_mainten: 0,
        maintenance_list: 0,
        maintenance_edit: 0,
        maintenance_status: 0
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const [yeardisplay, setyeardisp] = useState(new Date());
    const [loading, setLoading] = useState(false);

    const [datas, setData] = useState([]);
    const [responses, setresp] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    // page table data fetch
    const fetchData = () => {
        setLoading(true);
        const params = {
            month: yeardisplay.getMonth() + 1,
            year: yeardisplay.getFullYear(),
            page,
            per_page: perPage,
            search: searchTerm,
            branch_id: branch_id
        };
        axios.get(`${baseURL}/team_management/team_lead`, { params: params })
            .then(response => {
                setData(response.data.data);
                setresp(response.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage, yeardisplay]);


    const tableRef = useRef(null);
    const [month_fil_value, setMonthFilValue] = useState(new Date());

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };


    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const [isMaintenance, setIsMaintenance] = useState(false);
    // const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "team-lead"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    if (loading) {
        return <div>Loading...</div>; // optional loading state
    }

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Team Lead </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }


    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Team Lead</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Team Management</li>
                    </ol>
                </div>

                {permissions.team_lead_list === 1 && (
                    <div className="d-flex align-items-center justify-content-end mb-1">
                        <div className="w-60 mb-1 col-lg-8">
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker format="MMM-YYYY" value={yeardisplay} calendarPosition="top" mode="single" onlyMonthPicker={true} minDate={new Date(1900, 0, 1)} maxDate={new Date()} onChange={(date) => setyeardisp(new Date(date))} />
                                <div className='input-group-text bg-transparent border-0 px-0 py-0' style={{ padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}><i class="fa-solid fa-caret-down fs-4"></i></div>
                            </div>
                        </div>
                    </div>
                )}

            </div>

            <LoadingComponent loading={loading} />

            {permissions.team_lead_list === 1 && (
                <div className='row mb-2 mx-2'>
                    <div className='col-lg-10 col-sm-3 col-md-8 border border-gray800 py-2 d-flex align-items-center justify-content-start gap-3 flex-wrap rounded'>
                        <div className='d-flex align-items-center jsutify-content-start gap-2'>
                            <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#75ebae' }}>
                                <span></span>
                            </label>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Minimum Convertion Rate</span> </Tooltip>}>
                                <label className='fw-semibold text-black fs-6'>Minimum CR</label>
                            </OverlayTrigger>
                        </div>
                        <div className='d-flex align-items-center jsutify-content-start gap-2'>
                            <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#1d8348' }}>
                                <span></span>
                            </label>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Maximum Convertion Rate</span> </Tooltip>}>
                                <label className='fw-semibold text-black fs-6'>Maximum CR</label>
                            </OverlayTrigger>
                        </div>
                        <div className='d-flex align-items-center jsutify-content-start gap-2'>
                            <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#e74c3c' }}>
                                <span></span>
                            </label>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Minimum Average Business Value</span> </Tooltip>}>
                                <label className='fw-semibold text-black fs-6'>Minimum ABV</label>
                            </OverlayTrigger>
                        </div>
                        <div className='d-flex align-items-center jsutify-content-start gap-2'>
                            <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#c0392b' }}>
                                <span></span>
                            </label>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Maximum Average Business Value</span> </Tooltip>}>
                                <label className='fw-semibold text-black fs-6'>Maximum ABV</label>
                            </OverlayTrigger>
                        </div>
                        <div className='d-flex align-items-center jsutify-content-start gap-2'>
                            <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#078d73' }}>
                                <span></span>
                            </label>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Minimum Average Collection Value</span> </Tooltip>}>
                                <label className='fw-semibold text-black fs-6'>Minimum ACV</label>
                            </OverlayTrigger>
                        </div>
                        <div className='d-flex align-items-center jsutify-content-start gap-2'>
                            <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#2e86c1' }}>
                                <span></span>
                            </label>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Maximum Average Collection Value</span> </Tooltip>}>
                                <label className='fw-semibold text-black fs-6'>Maximum ACV</label>
                            </OverlayTrigger>
                        </div>
                    </div>
                </div>
            )}

            {permissions.team_lead_list === 1 && (
                <div className="table-container mb-4">

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{ fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); // Reset to first page
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{ fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>

                    <table style={{ borderBottom: '2px solid #ddd' }} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className="text-start align-top fw-bold fs-6 gs-0 bg-primary">
                                <th className="min-w-80px px-2 ">Sales Person</th>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">All Lead</span> </Tooltip>}>
                                    <th className="min-w-50px px-1 text-center">AL</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Monthly Lead</span> </Tooltip>}>
                                    <th className="min-w-50px px-1 text-center">ML</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Hot Lead</span> </Tooltip>}>
                                    <th className="min-w-50px px-1 text-center">HL</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Converted Customer</span> </Tooltip>}>
                                    <th className="min-w-50px px-1 text-center">CC</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Spam lead</span> </Tooltip>}>
                                    <th className="min-w-50px px-1 text-center">SL</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Dead Lead</span> </Tooltip>}>
                                    <th className="min-w-50px px-1 text-center">DL</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Spam Lead Ratio</span> </Tooltip>}>
                                    <th className="min-w-50px px-1 text-center">SLR</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Dead Lead Ratio</span> </Tooltip>}>
                                    <th className="min-w-80px px-1 text-center">DLR</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Current Convertion Rate</span> </Tooltip>}>
                                    <th className="min-w-80px px-1 text-center">CCR</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Average Convertion Rate</span> </Tooltip>}>
                                    <th className="min-w-80px px-1 text-center">ACR</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Average Business Value</span> </Tooltip>}>
                                    <th className="min-w-80px px-1 text-center">ABV</th>
                                </OverlayTrigger>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Average Collection Value</span> </Tooltip>}>
                                    <th className="min-w-80px px-1 text-center">ACV</th>
                                </OverlayTrigger>
                                {/* <th className="min-w-50px px-2 text-center">Action</th> */}
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                            {datas.length === 0 && hasFetched ? (
                                <tr>
                                    <td colSpan="14" className="text-center text-muted py-2">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {datas.map((data, index) => (
                                        <tr key={data.sales_person_id}>
                                            <td>
                                                <div className="d-flex align-items-center justify-content-start gap-2">
                                                    <LightGallery
                                                        onInit={onInit}
                                                        speed={500}
                                                        plugins={[lgThumbnail, lgZoom]}
                                                    >
                                                        <div data-src={data.sales_person_image} className='border rounded px-1 py-0'>
                                                            <img src={data.sales_person_image} alt={data.sales_person_name} className='cursor-pointer w-45px h-45px' />
                                                        </div>
                                                    </LightGallery>
                                                    <div>
                                                        <label className='text-black font-w400 fs-7'>{data.sales_person_name}</label>
                                                        <div className="d-block">
                                                            <label className="fs-8 text-dark">{data.sales_person_mobile}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#c0392b' }}>
                                                <label className='fw-bold text-white fs-7'>{data.total_lead}</label>
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#c0392b' }}>
                                                <label className='fw-bold text-white fs-7'>{data.month_lead}</label>
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#c0392b' }}>
                                                <label className='fw-bold text-white fs-7'>{data.hot_lead}</label>
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#c0392b' }}>
                                                <label className='fw-bold text-white fs-7'>{data.convert_customer}</label>
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#c0392b' }}>
                                                <label className='fw-bold text-white fs-7'>{data.spam_lead}</label>
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#c0392b' }}>
                                                <label className='fw-bold text-white fs-7'>{data.dead_lead}</label>
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#047961ff' }}>
                                                <label className='fw-bold text-white fs-7'>{data.SLR}</label>
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#047961ff' }}>
                                                <label className='fw-bold text-white fs-7'>{data.DLR}</label>
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#047961ff' }}>
                                                {data.is_max_ccr == 1 ? (
                                                    <label className='fw-bold text-white py-1 px-1 rounded fs-7' style={{ backgroundColor: '#1d8348' }}>{data.CCR}</label>
                                                ) : (
                                                    <label className='fw-bold text-black py-1 px-1 rounded fs-7' style={{ backgroundColor: '#75ebae' }}>{data.CCR}</label>
                                                )}
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#047961ff' }}>
                                                {data.is_max_acr == 1 ? (
                                                    <label className='fw-bold text-white py-1 px-1 rounded fs-7' style={{ backgroundColor: '#1d8348' }}>{data.ACR}</label>
                                                ) : (
                                                    <label className='fw-bold text-black py-1 px-1 rounded fs-7' style={{ backgroundColor: '#75ebae' }}>{data.ACR}</label>
                                                )}
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#047961ff' }}>
                                                {data.is_max_abv == 1 ? (
                                                    <label className='fw-bold text-white py-1 px-1 rounded fs-7' style={{ backgroundColor: '#c0392b' }}>{data.ABV}</label>
                                                ) : (
                                                    <label className='fw-bold text-white py-1 px-1 rounded fs-7' style={{ backgroundColor: '#e74c3c' }}>{data.ABV}</label>
                                                )}
                                            </td>
                                            <td align='center' style={{ backgroundColor: '#047961ff' }}>
                                                {data.is_max_acv == 1 ? (
                                                    <label className='fw-bold text-white py-1 px-1 rounded fs-7' style={{ backgroundColor: '#2e86c1' }}>{data.ACV}</label>
                                                ) : (
                                                    <label className='fw-bold text-white py-1 px-1 rounded fs-7' style={{ backgroundColor: '#078d73' }}>{data.ACV}</label>
                                                )}
                                            </td>
                                            {/* <td class="text-end">
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Set Lead Limit</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalLeadLimit(data)}>
                                                        <span><i class="fa-solid fa-gauge-high fs-3 mt-1"></i></span>
                                                    </Button>
                                                </OverlayTrigger>
                                            </td> */}
                                        </tr>
                                    ))}
                                </>
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {datas.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                </span>
                            ) : (
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}

                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                {/* Previous Button */}
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                        Previous
                                    </button>
                                </li>

                                {/* First Page */}
                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                        1
                                    </button>
                                </li>

                                {/* Left Ellipsis */}
                                {page > 4 && (
                                    <li className="page-item disabled">
                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                    </li>
                                )}

                                {/* Pages Around Current */}
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                    .map(p => (
                                        <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                {p}
                                            </button>
                                        </li>
                                    ))}

                                {/* Right Ellipsis */}
                                {page < totalPages - 3 && (
                                    <li className="page-item disabled">
                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                    </li>
                                )}

                                {/* Last Page */}
                                {totalPages > 1 && (
                                    <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                            {totalPages}
                                        </button>
                                    </li>
                                )}

                                {/* Next Button */}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>

                </div>
            )}

            {permissions.team_lead_list === 1 && (
                <div className='row mb-2 px-2 py-2 border border-gray800 rounded'>
                    <div className='col-11 d-flex p-2 m-auto d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-center'>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>Total Lead</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                <span className='fs-5 fw-bold text-primary'>{responses.total_all_lead}</span>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>Month Lead</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                <span className='fs-5 fw-bold text-primary'>{responses.total_month_lead}</span>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>Hot Lead</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                <span className='fs-5 fw-bold text-primary'>{responses.total_hot_lead}</span>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>Convert Customer</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                <span className='fs-5 fw-bold text-primary'>{responses.total_converted_customer}</span>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>Spam Lead</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                <span className='fs-5 fw-bold text-primary'>{responses.total_spam_lead}</span>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>Dead Lead</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                <span className='fs-5 fw-bold text-primary'>{responses.total_dead_lead}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-11 d-flex p-2 m-auto d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-center'>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>SLR</span>
                                <span className='d-block text-black fw-semibold fs-8'>(Spam Lead Ratio)</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                <span className='fs-5 fw-bold text-primary'>{responses.total_SLR}</span>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>DLR</span>
                                <span className='d-block text-black fw-semibold fs-8'>(Dead Lead Ratio)</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                <span className='fs-5 fw-bold text-primary'>{responses.total_DLR}</span>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>CCR</span>
                                <span className='d-block text-black fw-semibold fs-8'>(Current Convert Ratio)</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                {responses.is_max_ccr == 1 ? (
                                    <span className='fs-6 fw-bold text-white rounded px-2' style={{ backgroundColor: '#1d8348' }}>{responses.total_CCR}</span>
                                ) : (
                                    <span className='fs-6 fw-bold text-black rounded px-2' style={{ backgroundColor: '#75ebae' }}>{responses.total_CCR}</span>
                                )}
                            </div>
                        </div>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>ACR</span>
                                <span className='d-block text-black fw-semibold fs-8'>(Average Convert Ratio)</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                {responses.is_max_acr == 1 ? (
                                    <span className='fs-6 fw-bold text-white rounded px-2' style={{ backgroundColor: '#1d8348' }}>{responses.total_ACR}</span>
                                ) : (
                                    <span className='fs-6 fw-bold text-black rounded px-2' style={{ backgroundColor: '#75ebae' }}>{responses.total_ACR}</span>
                                )}
                            </div>
                        </div>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>ABV</span>
                                <span className='d-block text-black fw-semibold fs-8'>(Average Business Value)</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                {responses.is_max_avb === 1 ? (
                                    <span className='fs-6 fw-bold text-white rounded px-2' style={{ backgroundColor: '#c0392b' }}>{responses.total_AVB}</span>
                                ) : (
                                    <span className='fs-6 fw-bold text-white rounded px-2' style={{ backgroundColor: '#e74c3c' }}>{responses.total_AVB}</span>
                                )}
                            </div>
                        </div>
                        <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                            <div className='col-12 mb-2'>
                                <span className='text-black fw-semibold fs-6'>ACV</span>
                                <span className='d-block text-black fw-semibold fs-8'>(Average Collection Value)</span>
                            </div>
                            <div className='col-12 fw-bold fs-4 text-black'>
                                {responses.is_max_acv == 1 ? (
                                    <span className='fs-6 fw-bold text-white rounded px-2' style={{ backgroundColor: '#2e86c1' }}>{responses.total_ACV}</span>
                                ) : (
                                    <span className='fs-6 fw-bold text-white rounded px-2' style={{ backgroundColor: '#078d73' }}>{responses.total_ACV}</span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {permissions.team_lead_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

        </>
    )


}
export default TeamLead;